import type { SupabaseClient } from '@supabase/supabase-js';
import { getSupabaseClient } from '../data/supabase';

export interface QuoteChatReadInsert {
  messageId: string;
  eventId?: string;
  conversationId?: string;
  profileId: string;
}

export async function ensureQuoteChatReads(
  rows: QuoteChatReadInsert[],
  options?: { supabase?: SupabaseClient },
): Promise<void> {
  if (!rows.length) return;
  const supabase = options?.supabase ?? getSupabaseClient();
  const payload = rows.map((row) => ({
    message_id: row.messageId,
    event_id: row.eventId || null,
    conversation_id: row.conversationId || null,
    reader_profile_id: row.profileId,
  }));
  const { error } = await supabase
    .from('quote_chat_message_reads')
    .upsert(payload, { onConflict: 'message_id,reader_profile_id', ignoreDuplicates: true });
  if (error) {
    throw error;
  }
}
